import { authInstance, userInstance } from "../config/axios";

export const getAllUsers = async (setLiveUsers) => {
  try {
    const res = await userInstance.get(`/getUsers`);
    console.log("dfdfd =>", res.data);
    setLiveUsers(res.data.results);
    return res.data;
  } catch (error) {
    console.log("Error in getAllUsers api =>", error);
    return error.response.data;
  }
};

export const login = async (values) => {
  try {
    const res = await authInstance.post(`/login`, values);
    return res.data;
  } catch (error) {
    console.log("Error in login api =>", error);
    return error.response.data;
  }
};

export const signup = async (values) => {
  try {
    const res = await authInstance.post(`/register`, values);
    return res.data;
  } catch (error) {
    console.log("Error in singup api =>", error);
    return error.response.data;
  }
};

export const verifyEmail = async (token) => {
  try {
    const res = await authInstance.post(`/verify-email?token=${token}`);
    return res.data;
  } catch (error) {
    console.log("Error in singup api =>", error);
    return error.response.data;
  }
};
